export function useCollectionUtils() {
  const uniqValuesByKey = (arr, key) => {
    const seen = new Set()
    const out = []
    if (!Array.isArray(arr)) return out

    for (const it of arr) {
      const v = it?.[key]
      if (v == null) continue
      if (!seen.has(v)) {
        seen.add(v)
        out.push(v)
      }
    }
    return out
  }

  const uniqByKey = (arr, key) => {
    const seen = new Set()
    const out = []
    if (!Array.isArray(arr)) return out

    for (const it of arr) {
      const v = it?.[key]
      if (v == null) continue
      if (!seen.has(v)) {
        seen.add(v)
        out.push(it)
      }
    }
    return out
  }

  // ✅ NOVO: uniq po više ključeva (kao tvoj uniqBy([cat, subcat].join()))
  const uniqByKeys = (arr, keys) => {
    const seen = new Set()
    const out = []
    if (!Array.isArray(arr)) return out

    for (const it of arr) {
      const sig = keys.map(k => it?.[k] ?? '').join('|')
      if (sig === '') continue
      if (!seen.has(sig)) {
        seen.add(sig)
        out.push(it)
      }
    }
    return out
  }

  const groupByKey = (arr, key) => {
    const out = Object.create(null)
    if (!Array.isArray(arr)) return out

    for (const it of arr) {
      const k = it?.[key]
      const kk = k == null ? '__null__' : String(k)
      ;(out[kk] ||= []).push(it)
    }
    return out
  }

  return { uniqValuesByKey, uniqByKey, uniqByKeys, groupByKey }
}
